import React from 'react';
import { Column } from "rbx";
import { useParams } from "react-router-dom";
import Layout from "../../layout";
import AppNewForm from '../../../components/app/new';

const AppNewScreen = () => {
  const { cpf } = useParams();

  return (
    <Layout>
      <Column.Group centered>
        <Column size={5}>
          <AppNewForm cpf={cpf}/>
        </Column>
      </Column.Group>
    </Layout>
  )

}

export default AppNewScreen;
